export const Status = {
    NotStarted: 'not-started',
    InProgress: 'in-progress',
    Completed: 'completed',
    Failed: 'failed',
}